import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .nameOverride([
    'value',
    'purchasePrice',
    'vehicleMake',
    'vehicleModel',
  ], {
    _customProps: {
      fullWidth: false,
    },
  }, overrideReadOnly)
  // I can't change the real asset resource because it's already in use in other places.
  // But we're not supposed to let members adjust the type (not the subtype within the larger type, but the overarching type) anymore, and the mutator doesn't handle it anyway on the backend
  .nameOverride('type', { hidden: true })
  // It's weird to just see "Sub type" without any "Type" field, and during the add step we call it Category. At the same time, I don't want to touch the existing real asset resource since it's used in other places
  .nameOverride('subType', { prompt: 'Category' });

export default metaOverrideSet;
